const host = `${process.env.REACT_APP_BASE_URL}/cms/`;
const host2 = `${process.env.REACT_APP_BASE_URL}/csat/`;
const host_cms_project = `${process.env.REACT_APP_BASE_URL}/cms/`;
const host_rbac = `${process.env.REACT_APP_BASE_URL}/rbac`;

const endpoints = {
	REFERRAL_LOGIN: `${host}referral/customer`,
	REFERRAL_LOGIN_CSAT: `${host}referral/customer/csat`,
	REFERRAL: `${host}referral`,
	CHECK_STATUS_LOGIN: `${host}referral/customer/login`,
	CHECK_STATUS_VERIFY_OTP: `${host}referral/customer/verify-otp`,
	SAVE_BANK_DETAILS: `${host}referral/customer/bank-details`,
	GET_CSAT_DETAILS: `${host2}csat`,
	CSAT_REFERRAL: `${host}referral/csat`,
	GET_PROJECT_DETAILS:`${host_cms_project}project/project/personalized-link`,
	FORGOT_PASSWORD_ENDPOINT_VALIDATE:`${host_rbac}/auth/validate-forgot-password`,
	FORGOT_PASSWORD_ENDPOINT_UPDATE:`${host_rbac}/auth/update-password`,
	RESET_CREDENTIALS_ENDPOINT_UPDATE:`${host_rbac}/auth/forgot-password`,
};

export default endpoints;
